import { api } from "../features/config/ApiConfig";
import { COMN_CODE_API } from "../constants";

export const getCode = async (args: {
    comnCd?: string;
    keyword?: string;
    keywordName?: string;
    area?: string;
    page?: number;
    size?: number;
    langCd?: string;
    param1?: string;
    param2?: string;
    param3?: string;
    param4?: string;
    param5?: string;
    param6?: string;
    param7?: string;
}) => {
    const {
        comnCd = "",
        area,
        size = 999999,
        page = 0,
        keyword = "",
        keywordName = "",
        langCd = "",
        param1 = "",
        param2 = "",
        param3 = "",
        param4 = "",
        param5 = "",
        param6 = "",
        param7 = "",
    } = args;

    let url = "";

    switch (area) {
        // 포탈 내외부 분기
        case "comnCd":
            url = `${COMN_CODE_API}/comn-cd?comnCd=${comnCd}&cdVldVal=${keyword}&cdVldValNm=${keywordName}&langCd=${langCd}`;
            break;
        case "cityCd":
            url = `${COMN_CODE_API}/regn/city-cd?regnCd=${keyword}&regnNm=${keywordName}&cntyCd=${param1}&cntyCdArr=${param2}&regnTpCd=${param3}`;
            break;
        case "unLocCd":
            url = `${COMN_CODE_API}/regn/city-cd?regnCd=${keyword}&regnNm=${keywordName}&cntyCd=${param1}&cntyCdArr=${param2}&regnTpCd=02`;
            break;
        case "portCd":
            url = `${COMN_CODE_API}/regn/port-cd?regnCd=${keyword}&regnNm=${keywordName}&cntyCd=${param1}&cntyCdArr=${param2}`;
            break;
        case "cntyCd":
            url = `${COMN_CODE_API}/cnty-cd?cntyCd=${keyword}&cntyNm=${keywordName}`;
            break;
        case "dgt3CntyCd":
            url = `${COMN_CODE_API}/dgt3-cnty-cd?dgt3CntyCd=${keyword}&cntyNm=${keywordName}`;
            break;
        case "dgt3NumCntyCd":
            url = `${COMN_CODE_API}/dgt3-num-cnty-cd?dgt3NumCntyCd=${keyword}&cntyNm=${keywordName}`;
            break;
        case "currCd":
            url = `${COMN_CODE_API}/curr-cd?currCd=${keyword}&currNm=${keywordName}`;
            break;
        case "bnkCd":
            url = `${COMN_CODE_API}/comn-cd?comnCd=OSC0084&cdVldVal=${keyword}&cdVldValNm=${keywordName}`;
            break;
        case "portAirptCd":
            url = `${COMN_CODE_API}/regn/port-airpt-cd?regnCd=${keyword}&regnNm=${keywordName}&portAirptTpCd=${param1}&cntyCd=${param2}&cntyCdArr=${param3}`;
            break;
        case "airptCd":
            url = `${COMN_CODE_API}/regn/airpt-cd?regnCd=${keyword}&regnNm=${keywordName}&cntyCd=${param1}&cntyCdArr=${param2}`;
            break;
        case "prcssStatCd":
            url = `${COMN_CODE_API}/prcss-stat-cd?bsopPrcssStatCd=COM_9000&item=${keyword}&itemNm=${keywordName}`;
            break;
        case "orgCd":
            url = `${COMN_CODE_API}/org?orgTpCd=01&orgCd=${keyword}&orgNm=${keywordName}&lpcoIssuYn=${param1}&orgAbrtYn=${param2}`;
            break;
        case "orgAbrt":
            url = `${COMN_CODE_API}/orgAbrt?orgTpCd=01&orgCd=${keyword}&orgNm=${keywordName}&lpcoIssuYn=${param1}&orgAbrtYn=${param2}`;
            break;
        case "wrhsCd":
            url = `${COMN_CODE_API}/wrhs?coDclaCd=${keyword}&wrhsNm=${keywordName}&wrhsOprtTpCd=${param1}&cstmOfceCd=${param2}`;
            break;
        case "carrCd":
            url = `${COMN_CODE_API}/carr?coDclaCd=${keyword}&carrNm=${keywordName}`;
            break;
        case "coDclaCd":
            url = `${COMN_CODE_API}/co-dcla-cd?coCd=${keyword}&coNm=${keywordName}&coTin=${param1}&coTpCd=${param2}&spcdlWrhsYn=${param3}&coCds=${param4}`;
            break;
        case "orgDeptCd":
            url = `${COMN_CODE_API}/org-dept?deptCd=${keyword}&deptNm=${keywordName}&orgCd=${param1}&orgNm=${param2}`;
            break;
        case "cstmCd":
            url = `${COMN_CODE_API}/cstm?cstmOfceCd=${keyword}&cstmNm=${keywordName}&dclrYn=${param2}&cstmTpCd=${param1}&cstmOfceCdArr=${param3}`;
            break;
        case "cstmOfcrCd":
            url = `${COMN_CODE_API}/cstmOfcr?usrNm=${keyword}&cstmOfceCd=${keywordName}&usrDmnId=${param1}&usrStatCd=${param2}&roleId=${param3}`;
            break;
        case "vhclBodyCd":
            url = `${COMN_CODE_API}/vhcl/body?vhclBodyTpCd=${keyword}&vhclBodyTpNm=${keywordName}`;
            break;
        case "vhclCtgrCd":
            url = `${COMN_CODE_API}/vhcl/ctgr?vhclCtgrCd=${keyword}&vhclCtgrNm=${keywordName}`;
            break;
        case "vhclClrCd":
            url = `${COMN_CODE_API}/vhcl/clr?vhclClrCd=${keyword}&vhclClrNm=${keywordName}`;
            break;
        case "vhclFlCd":
            url = `${COMN_CODE_API}/vhcl/fl?vhclFlTpCd=${keyword}&vhclFlNm=${keywordName}`;
            break;
        case "vhclMkerCd":
            url = `${COMN_CODE_API}/vhcl/mker?vhclMkerCd=${keyword}&vhclMkerNm=${keywordName}`;
            break;
        case "vhclImpCntyCd":
            url = `${COMN_CODE_API}/vhcl/imp-cnty?vhclCntyCd=${keyword}&vhclCntyNm=${keywordName}`;
            break;
        case "vhclInsrTpCd":
            url = `${COMN_CODE_API}/vhcl/insr-tp?vhclInsrTpCd=${keyword}&vhclInsrTpNm=${keywordName}`;
            break;
        case "vhclMdlCd":
            url = `${COMN_CODE_API}/vhcl/mdl?vhclMdlCd=${keyword}&vhclMdlNm=${keywordName}&vhclMkerCd=${param1}`;
            break;
        case "vhclMdlNoCd":
            url = `${COMN_CODE_API}/vhcl/mdl-no?vhclMdlNoCd=${keyword}&vhclMdlNoNm=${keywordName}&vhclMkerCd=${param1}&vhclMdlCd=${param2}`;
            break;
        case "vhclHlpnCtgrCd":
            url = `${COMN_CODE_API}/vhcl/hlpn-ctgr?vhclHlpnCtgrCd=${keyword}&vhclHlpnCtgrNm=${keywordName}`;
            break;
        case "vhclPrplTpCd":
            url = `${COMN_CODE_API}/vhcl/prpl-tp?vhclPrplTpCd=${keyword}&vhclPrplTpNm=${keywordName}`;
            break;
        case "vhclTrmssnTpCd":
            url = `${COMN_CODE_API}/vhcl/trmssn-tp?vhclTrmssnTpCd=${keyword}&vhclTrmssnTpNm=${keywordName}`;
            break;
        case "vhclUseCd":
            url = `${COMN_CODE_API}/vhcl/use?vhclUseCd=${keyword}&vhclUseNm=${keywordName}`;
            break;
        case "trmnlOptrCd":
            url = `${COMN_CODE_API}/trmnloptr?trmnlOptrCd=${keyword}&trmnlOptrNm=${keywordName}`;
            break;
        case "tb":
            url = `${COMN_CODE_API}/tb?tbId=${keyword}&tbNm=${keywordName}`;
            break;
        case "indvCdTb":
            url = `${COMN_CODE_API}/tb-indv-cd?tbId=${keyword}&tbNm=${keywordName}`;
            break;
        case "col":
            url = `${COMN_CODE_API}/col?colId=${keyword}&colNm=${keywordName}&tbId=${param1}`;
            break;
        case "indvCdCol":
            url = `${COMN_CODE_API}/col-indv-cd?colId=${keyword}&colNm=${keywordName}&tbId=${param1}`;
            break;
        case "lbl":
            url = `${COMN_CODE_API}/lbl?lblId=${keyword}&lblNm=${keywordName}`;
            break;
        case "comnCdMstr":
            url = `${COMN_CODE_API}/comn-cd-mstr?comnCd=${keyword}&comnCdNm=${keywordName}`;
            break;
        case "dclt":
            url = `${COMN_CODE_API}/dclt?dcltTin=${keyword}&dcltNm=${keywordName}`;
            break;
        case "coUsr":
            url = `${COMN_CODE_API}/co-usr?usrId=${keyword}&usrNm=${keywordName}`;
            break;
        case "orgUsr":
            url = `${COMN_CODE_API}/org-usr?usrId=${keyword}&usrNm=${keywordName}`;
            break;
        case "coBucn":
            url = `${COMN_CODE_API}/co-bucn?bucnTin=${keyword}&bucnNm=${keywordName}&coTin=${param1}`;
            break;
        case "hldy":
            url = `${COMN_CODE_API}/hldy?hldyId=${keyword}&hldyNm=${keywordName}&ctraYy=${param1}&hldyTpCd=${param2}`;
            break;
        case "roleCd":
            url = `${COMN_CODE_API}/role?roleId=${keyword}&roleNm=${keywordName}`;
            break;
        // case "cgmePrcdCd":
        //     url = `${process.env.REACT_APP_API_CGME}/api/v1/cgme/comn/cd?area=cgmePrcdCd&comnCd=${comnCd}`;
        //     break;
        // case "cgmiPrcdCd":
        //     url = `${process.env.REACT_APP_API_CGMI}/api/v1/cgmi/comn/cd?area=cgmiPrcdCd&comnCd=${comnCd}`;
        //     break;
        // case "cgmeLstCd":
        //     url = `${process.env.REACT_APP_API_CGME}/api/v1/cgme/comn/cd?area=cgmeLstCd&comnCd=${comnCd}`;
        //     break;
        // case "cgmiLstCd":
        //     url = `${process.env.REACT_APP_API_CGMI}/api/v1/cgmi/comn/cd?area=cgmiLstCd&comnCd=${comnCd}`;
        //     break;
        case "hsCdPopupPtl":
            url = `${process.env.REACT_APP_API_PTL_COMN}/api/v1/comn/comn/hs-mgmt?popUp=Y&hsCd=${keyword}&hsDesc=${keywordName}&hsDgt=${param1}`;
            break;
        case "postCd":
            url = `${process.env.REACT_APP_API_PTL_COMN}/api/v1/osci/comn/ppup/post-cd?postCd=${keyword}&postNm=${keywordName}&postTpCd=${param1}`;
            break;
        // case "ectePrcdCd":
        //     url = `${process.env.REACT_APP_API_ECTE}/api/v1/ecte/comn/cd?area=ectePrcdCd&comnCd=${comnCd}`;
        //     break;
        // case "ectiPrcdCd":
        //     url = `${process.env.REACT_APP_API_ECTI}/api/v1/ecti/comn/cd?area=ectiPrcdCd&comnCd=${comnCd}`;
        //     break;

        case "hsCd": {
            let api;
            api = `${process.env.REACT_APP_API_OSCI}`;
            url = `${api}/api/v1/osci/lpco/comn/comn-cd/hsCdList?hsCd=${keyword}&hsDesc=${keywordName}&hsDgt=${param1}`;
            break;
        }
        case "hsCdPopup": {
            let api;
            api = `${process.env.REACT_APP_API_OSCI}`;
            url = `${api}/api/v1/osci/lpco/comn/comn-cd/hsCdList?hsCd=${keyword}&hsDesc=${keywordName}&hsDgt=${param1}`;
            break;
        }
        case "csldrTin": {
            url = `${process.env.REACT_APP_API_OSCI}/api/v1/eswe/lpco/csld/ppup/csldrTin?srchCsldrTin=${keyword}&srchCsldrNm=${keywordName}&srchCsldrAddr=${param1}`;
            break;
        }
        case "dclrPrcdCd": {
            url = `${COMN_CODE_API}/dclrPrcdCd?area=dclrPrcdCd&comnCd=${comnCd}`;
            break;
        }
        case "profile": {
            url = `${COMN_CODE_API}/profile?idntfNo=${keyword}&coNm=${keywordName}&profile=${param1}&prflDvnCd=${param2}`;
            break;
        }
        case "prflCo": {
            url = `${COMN_CODE_API}/profile?idntfNo=${keyword}&coNm=${keywordName}&profile=co&prflDvnCd=${param2}`;
            break;
        }
        case "prflCsbr": {
            url = `${COMN_CODE_API}/profile?idntfNo=${keyword}&coNm=${keywordName}&profile=csbr&prflDvnCd=02`;
            break;
        }
        case "prflCsbrCo": {
            url = `${COMN_CODE_API}/profile?idntfNo=${keyword}&coNm=${keywordName}&profile=csbr&prflDvnCd=01`;
            break;
        }
        case "prflHscd": {
            url = `${COMN_CODE_API}/profile?idntfNo=${keyword}&coNm=${keywordName}&profile=hscd&prflDvnCd=${param2}`;
            break;
        }
        default:
            url = `${COMN_CODE_API}/comn-cd?comnCd=${comnCd}&cdVldVal=${keyword}&cdVldValNm=${keywordName}&langCd=${langCd}`;
            break;
    }

    if (size) url += `&size=${size}`;
    if (page) url += `&page=${page}`;

    return api.get(url);
};

export const getCodeLabel = (area?: string, code?: any) => {
    switch (area) {
        case "comnCd":
            return code.cdVldValNm;
        case "cntyCd":
        case "unLocCd":
            return code.cntyNm;
        case "dgt3CntyCd":
            return code.cntyNm;
        case "dgt3NumCntyCd":
            return code.cntyNm;
        case "cityCd":
            return code.regnNm;
        case "portCd":
            return code.regnNm;
        case "currCd":
            return code.currNm;
        case "bnkCd":
            return code.cdVldValNm;
        case "portAirptCd":
            return code.regnNm;
        case "airptCd":
            return code.regnNm;
        case "prcssStatCd":
            return code.itemNm;
        case "orgCd":
            return code.orgNm;
        case "orgAbrt":
            return code.orgAbrtNm;
        case "wrhsCd":
            return code.wrhsNm;
        case "carrCd":
            return code.carrNm;
        case "coDclaCd":
            return code.coNm;
        case "orgDeptCd":
            return code.deptNm;
        case "cstmCd":
            return code.cstmNm;
        case "cstmOfcrCd":
            return code.usrNm;
        case "vhclBodyCd":
            return code.vhclBodyTpNm;
        case "vhclCtgrCd":
            return code.vhclCtgrNm;
        case "vhclClrCd":
            return code.vhclClrNm;
        case "vhclFlCd":
            return code.vhclFlNm;
        case "vhclMkerCd":
            return code.vhclMkerNm;
        case "vhclImpCntyCd":
            return code.vhclCntyNm;
        case "vhclInsrTpCd":
            return code.vhclInsrTpNm;
        case "vhclMdlCd":
            return code.vhclMdlNm;
        case "vhclMdlNoCd":
            return code.vhclMdlNoNm;
        case "vhclHlpnCtgrCd":
            return code.vhclHlpnCtgrNm;
        case "vhclPrplTpCd":
            return code.vhclPrplTpNm;
        case "vhclTrmssnTpCd":
            return code.vhclTrmssnTpNm;
        case "vhclUseCd":
            return code.vhclUseNm;
        case "cgmePrcdCd":
        case "cgmiPrcdCd":
        case "cgmeLstCd":
        case "cgmiLstCd":
        case "ectePrcdCd":
        case "ectiPrcdCd":
            return code.comnCdLbl;
        case "hsCd":
        case "hsCdPopup":
            return code.hsDesc;
        case "postCd":
            return code.wardPostNm + ", " + code.dstrPostNm + ", " + code.regnPostNm;
        case "trmnlOptrCd":
            return code.trmnlOptrNm;
        case "tb":
        case "indvCdTb":
            return code.tbNm;
        case "col":
        case "indvCdCol":
            return code.colNm;
        case "lbl":
            return code.lblNm;
        case "comnCdMstr":
            return code.comnCdNm;
        case "dclt":
            return code.dcltNm;
        case "coUsr":
            return code.usrNm;
        case "orgUsr":
            return code.usrNm;
        case "coBucn":
            return code.bucnNm;
        case "hldy":
            return code.hldyNm;
        case "csldrTin":
            return code.csldrNm;
        case "dclrPrcdCd":
            return code.comnCdLbl;
        case "profile":
            return code.coNm;
        case "prflCo":
            return code.coNm;
        case "prflCsbr":
            return code.coNm;
        case "prflCsbrCo":
            return code.coNm;
        case "prflHscd":
            return code.coNm;
        default:
            return code.cdVldValNm;
    }
};

export const getCodeValue = (area?: string, code?: any) => {
    switch (area) {
        case "comnCd":
            return code.cdVldVal;
        case "cntyCd":
        case "unLocCd":
            return code.cntyCd;
        case "dgt3CntyCd":
            return code.dgt3CntyCd;
        case "dgt3NumCntyCd":
            return code.dgt3NumCntyCd;
        case "cityCd":
            return code.regnCd;
        case "portCd":
            return code.regnCd;
        case "currCd":
            return code.currCd;
        case "bnkCd":
            return code.cdVldVal;
        case "portAirptCd":
            return code.regnCd;
        case "airptCd":
            return code.regnCd;
        case "prcssStatCd":
            return code.item;
        case "orgCd":
            return code.orgCd;
        case "orgAbrt":
            return code.orgCd;
        case "wrhsCd":
            return code.coDclaCd;
        case "carrCd":
            return code.coDclaCd;
        case "coDclaCd":
            return code.coCd;
        case "orgDeptCd":
            return code.deptCd;
        case "cstmCd":
            return code.cstmOfceCd;
        case "cstmOfcrCd":
            return code.usrDmnId;
        case "vhclBodyCd":
            return code.vhclBodyTpCd;
        case "vhclCtgrCd":
            return code.vhclCtgrCd;
        case "vhclClrCd":
            return code.vhclClrCd;
        case "vhclFlCd":
            return code.vhclFlTpCd;
        case "vhclMkerCd":
            return code.vhclMkerCd;
        case "vhclImpCntyCd":
            return code.vhclCntyCd;
        case "vhclInsrTpCd":
            return code.vhclInsrTpCd;
        case "vhclMdlCd":
            return code.vhclMdlCd;
        case "vhclMdlNoCd":
            return code.vhclMdlNoCd;
        case "vhclHlpnCtgrCd":
            return code.vhclHlpnCtgrCd;
        case "vhclPrplTpCd":
            return code.vhclPrplTpCd;
        case "vhclTrmssnTpCd":
            return code.vhclTrmssnTpCd;
        case "vhclUseCd":
            return code.vhclUseCd;
        case "cgmePrcdCd":
        case "cgmiPrcdCd":
        case "cgmeLstCd":
        case "cgmiLstCd":
        case "ectePrcdCd":
        case "ectiPrcdCd":
            return code.comnCdVal;
        case "hsCd":
        case "hsCdPopup":
            return code.hsCd;
        case "postCd":
            return code.wardPostCd;
        case "trmnlOptrCd":
            return code.trmnlOptrCd;
        case "tb":
        case "indvCdTb":
            return code.tbId;
        case "col":
        case "indvCdCol":
            return code.colId;
        case "lbl":
            return code.lblId;
        case "comnCdMstr":
            return code.comnCd;
        case "dclt":
            return code.dcltTin;
        case "coUsr":
            return code.usrId;
        case "orgUsr":
            return code.usrId;
        case "coBucn":
            return code.bucnTin;
        case "hldy":
            return code.ctraDt;
        case "csldrTin":
            return code.csldrTin;
        case "dclrPrcdCd":
            return code.comnCdVal;
        case "profile":
            return code.idntfNo;
        case "prflCo":
            return code.idntfNo;
        case "prflCsbr":
            return code.idntfNo;
        case "prflCsbrCo":
            return code.idntfNo;
        case "prflHscd":
            return code.idntfNo;
        default:
            return code.cdVldVal;
    }
};

export const getCodeOptions = (area?: string, codes?: any[]) => {
    return (
        codes?.map((code) => {
            return { label: getCodeLabel(area, code), value: getCodeValue(area, code) };
        }) || []
    );
};
